<!-- Name && Icon -->
@if (icon === true && name === true) {
  @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Male) {
    <div class="flex items-center space-x-1">
      <ng-container [ngTemplateOutlet]="genderIcon" [ngTemplateOutletContext]="{gender:'male'}"></ng-container>
      <span>{{ 'Male' | localizeText : 'Male' }}</span>
    </div>
  }
  @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Female) {
    <div class="flex items-center space-x-1">
      <ng-container [ngTemplateOutlet]="genderIcon" [ngTemplateOutletContext]="{gender:'female'}"></ng-container>
      <span>{{ 'Female' | localizeText : 'Female' }}</span>
    </div>
  }
  @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Other) {
    <div class="flex items-center space-x-1">
      <ng-container [ngTemplateOutlet]="genderIcon" [ngTemplateOutletContext]="{gender:'other'}"></ng-container>
      <span>{{ 'Other' | localizeText : 'Other' }}</span>
    </div>
  }
}


<!-- Name Only -->
@if (icon === false && name === true) {
  <div>
    @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Male) {
      <span>{{ 'Male' | localizeText : 'Male' }}</span>
    }
    @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Female) {
      <span> {{ 'Female' | localizeText : 'Female' }}</span>
    }
    @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Other) {
      <span>{{ 'Other' | localizeText : 'Other' }}</span>
    }
  </div>
}

<!-- Icon Only -->
@if (icon === true && name === false) {
  @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Male) {
    <ng-container [ngTemplateOutlet]="genderIcon" [ngTemplateOutletContext]="{gender:'male'}"></ng-container>
  }
  @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Female) {
    <ng-container [ngTemplateOutlet]="genderIcon" [ngTemplateOutletContext]="{gender:'female'}"></ng-container>
  }
  @if (fitMedProfileValue && fitMedProfileValue.gender === gender.Other) {
    <ng-container [ngTemplateOutlet]="genderIcon" [ngTemplateOutletContext]="{gender:'other'}"></ng-container>
  }
}

<ng-template #genderIcon let-gender="gender">
  <app-icon [icon]="gender" [height]="height" [width]="width"></app-icon>
</ng-template>
